import type { IconName } from '@elara/client-core/ui-contracts/icon-name';

import { getPlaceIcon } from './place-category.js';

/** Fallback Material icon for a card's cover image when the entity has no photo. */
export function getFallbackCoverImageIcon(type: string): IconName {
  switch (type) {
    case 'hotel': {
      return 'hotel';
    }
    case 'flight': {
      return 'flight';
    }
    case 'room': {
      return 'hotel';
    }
    case 'destination': {
      return 'place';
    }
    case 'activity':
    case 'custom': {
      return 'event';
    }
    default: {
      return getPlaceIcon(type);
    }
  }
}
